module.exports = __webpack_public_path__ + "img/home-4.c640f8d0.webp";